export default function auth ({to, next, store, nextMiddleWare }){
    let pages = ['login', 'auth-password-reset', 'auth-password-reset-verify-token', 'auth-register'];

    if(store.getters.isUserAuthenticated) {
        if(pages.includes(to.name)) {
            return next({name: "dashboard"});
        } else if(nextMiddleWare) {
            return nextMiddleWare();
        }
    } else if(!pages.includes(to.name)) {
        return next({ name: 'login' });
    }

    return next();
}